module.exports = __webpack_public_path__ + "static/uni_welfare-7b2d79fd8edda262f874ad9c3ff9ef90.png";